import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/auth";
import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";

function Routes() {
    const { signed, loading, getLogin, logoutLogin } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get("token");
        const email = queryParams.get("email");

        if (token && email && location.pathname !== "/renovarsenha") {
            logoutLogin();
            getLogin(email, "senha", token);

            navigate(
                { pathname: location.pathname, search: "" },
                { replace: true },
            );
        }
    }, [location.search, location.pathname, logoutLogin, getLogin, navigate]);

    if (loading) return null;

    return signed ? <AppRoutes /> : <AuthRoutes />;
}

export default Routes;
